import React from "react";

import "./styles.scss";

import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";

const Breadcrumb = ({ routes }) => {
  const history = useHistory();
  return (
    <div className={"breadcrumb"}>
      {routes.map(({ route, title }, i) => [
        <p
          key={`breadcrumb:${i}`}
          onClick={() => {
            history.push(route);
          }}
          className={i === routes.length - 1 && "current"}>
          {title}
        </p>,
        i !== routes.length - 1 && <p>&gt;</p>,
      ])}
    </div>
  );
};

Breadcrumb.propTypes = {
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      route: PropTypes.string.isRequired,
      rotitleute: PropTypes.string.isRequired,
    }),
  ),
};

Breadcrumb.defaultProps = {};

export default Breadcrumb;
